import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinmadhapurhyderabad() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Madhapur Hyderabad',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Madhapur Hyderabad',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Madhapur Hyderabad, catering to the transportation needs of IT companies, corporate offices, and business hubs in the area. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and punctual travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Madhapur Hyderabad.',

    top: 'Top Places to Visit in Hyderabad with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Charminar",
    "description": "Charminar is Hyderabad’s most iconic landmark, built in 1591 by Sultan Muhammad Quli Qutb Shah. This grand square-shaped monument features four towering minarets and intricate Islamic architecture. Surrounded by bustling bazaars, street food vendors, and shops selling pearls, bangles, and traditional crafts, Charminar is a cultural and historical hub, attracting tourists from across India and the world."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a majestic fortress located on the outskirts of Hyderabad, known for its massive walls, impressive gateways, and acoustic marvels. Once the capital of the Qutb Shahi dynasty, it offers panoramic views of the city and nearby hills. The evening light and sound show narrates the fort’s rich history, making it a favorite destination for history enthusiasts and photographers."
  },
  {
    "title": "Hussain Sagar Lake",
    "description": "Hussain Sagar Lake is a large man-made lake in the heart of Hyderabad, famous for the gigantic Buddha statue standing on Gibraltar Rock in the middle of the water. The lake is popular for boating, evening walks, and lakeside leisure. Surrounded by parks, eateries, and promenades, it serves as a serene escape and recreational spot for locals and tourists."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum is one of India’s largest museums, housing an extensive collection of art, sculptures, manuscripts, and artifacts from India and around the world. Visitors can explore centuries of history and culture through exhibits such as Mughal miniatures, European paintings, and decorative arts. The museum provides an immersive educational experience for art and history enthusiasts."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City is one of the world’s largest film studio complexes and a popular entertainment destination near Hyderabad. Spread across thousands of acres, it features film sets, amusement rides, gardens, and live shows. Visitors can enjoy guided tours, interactive experiences, and cultural performances, making it a top choice for family outings and film enthusiasts."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace is a stunning 18th-century palace that once served as the seat of the Nizams of Hyderabad. The complex features grand halls, intricate interiors, beautiful courtyards, and royal artifacts. Visitors can explore the opulent architecture and learn about the history and lifestyle of the Nizams, making it a cultural and historical gem of the city."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir is a magnificent white marble temple dedicated to Lord Venkateswara, located on a hill overlooking Hyderabad. The temple offers panoramic views of the city and the lake below. Visitors can admire the detailed carvings, serene surroundings, and participate in spiritual rituals, making it a peaceful retreat in the heart of the city."
  },
  {
    "title": "Laad Bazaar",
    "description": "Laad Bazaar, located near Charminar, is Hyderabad’s famous shopping street, known for its vibrant bangles, jewelry, pearls, textiles, and handicrafts. The bustling markets and colorful storefronts create an authentic local experience. It is a must-visit for tourists looking to shop, explore, and enjoy the vibrant culture of the old city."
  },
  {
    "title": "Necklace Road",
    "description": "Necklace Road is a scenic boulevard along Hussain Sagar Lake, popular for evening walks, recreational activities, and lakeside dining. It features landscaped gardens, jogging tracks, and food stalls. The area is ideal for leisure, family outings, and enjoying the illuminated view of the Buddha statue on the lake."
  },
  {
    "title": "Qutb Shahi Tombs",
    "description": "The Qutb Shahi Tombs are the royal necropolis of the Qutb Shahi dynasty, located near Golconda Fort. The complex features grand domed tombs, landscaped gardens, and intricate stonework. Visitors can explore the historical architecture, learn about the dynasty’s legacy, and enjoy peaceful walks amidst the ancient structures."
  }
],


"services": [
{
"name": "Madhapur Corporate Cab",
"description": "Madhapur Corporate Cab provides fully managed, tech-enabled corporate transportation for IT parks, business hubs, and corporate offices across Madhapur. With a trained chauffeur network, a diverse fleet of sedans, SUVs, and premium cars, and real-time GPS tracking, it ensures punctual, safe, and comfortable employee and executive travel. Designed for organizations of all sizes, the service supports multi-shift operations, flexible routes, and seamless office commuting tailored to Madhapur’s high-density business environment."
},
{
"name": "IT Park Shuttle Madhapur",
"description": "IT Park Shuttle Madhapur delivers high-capacity shuttle mobility for companies operating in the Madhapur–Hitech City corridor. With AC minibuses, optimized routing, centralized scheduling, and real-time attendance integration, it efficiently manages large workforce movement. Ideal for IT companies and tech parks, the service supports peak hours, multi-shift travel, and zone-to-zone employee mobility with strong safety and coordination standards."
},
{
"name": "Business Taxi Madhapur",
"description": "Business Taxi Madhapur provides executive-level transportation for meetings, client travel, airport transfers, and inter-office mobility. With modern vehicles driven by trained corporate chauffeurs, the service focuses on punctuality, comfort, and a premium business travel experience. It is ideal for CEOs, managers, visiting clients, and corporate teams requiring reliable and well-organized travel in and around Madhapur."
},
{
"name": "Employee Commute Madhapur",
"description": "Employee Commute Madhapur offers structured daily transportation for employees working in IT, corporate, and tech hubs of Madhapur. With GPS tracking, optimized pickup–drop routes, verified drivers, and shift-based scheduling, it ensures safe, consistent, and timely commuting. The system supports fixed, flexible, rotational, and multi-shift travel for companies of varying workforce sizes."
},
{
"name": "Staff Pickup Drop Madhapur",
"description": "Staff Pickup Drop Madhapur ensures seamless doorstep-to-office and office-to-home mobility with pre-planned routes, trained drivers, and real-time monitoring. Suitable for both large corporate teams and smaller companies, this service guarantees punctuality, safety, and operational reliability across all business zones of Madhapur."
},
{
"name": "Monthly Cab Madhapur",
"description": "Monthly Cab Madhapur provides long-term corporate cab services with dedicated vehicles, professional drivers, predictable pricing, and 24/7 operational support. Designed for companies that require consistent employee and executive mobility, it includes maintenance, GPS tracking, safety audits, and assured vehicle availability every day of the month."
},
{
"name": "Affordable Corporate Cab Madhapur",
"description": "Affordable Corporate Cab Madhapur offers budget-friendly yet dependable transportation solutions for startups, SMEs, and mid-sized IT firms. With efficient route planning, clean vehicles, trained chauffeurs, and transparent pricing, it ensures economical daily commuting without compromising comfort, safety, or service standards."
},
{
"name": "Best Cab Madhapur",
"description": "Best Cab Madhapur delivers premium-quality corporate cab services featuring top-tier vehicles, well-groomed chauffeurs, enhanced safety protocols, and consistently punctual operations. Suitable for senior managers, executives, and important business visitors, it guarantees a superior and smooth travel experience across the Madhapur business zone."
},
{
"name": "Outstation Cab Madhapur",
"description": "Outstation Cab Madhapur offers long-distance travel solutions for corporate meetings, factory visits, intercity client trips, and executive tours. Equipped with comfortable sedans and SUVs, experienced chauffeurs, interstate permits, and real-time tracking, it ensures secure, hassle-free, and well-coordinated outstation commuting for corporate clients."
},
{
"name": "Sedan Cab Madhapur",
"description": "Sedan Cab Madhapur provides executive sedans suitable for business meetings, airport transfers, daily office commute, and VIP movement. With refined interiors, experienced drivers, and smooth ride quality, it ensures a comfortable and professional corporate travel experience for employees and executives alike."
},
{
"name": "SUV Cab Madhapur",
"description": "SUV Cab Madhapur delivers spacious and premium SUVs ideal for senior management travel, team movement, outstation trips, and long business drives. With advanced comfort features, high safety standards, and trained chauffeurs, it ensures superior corporate travel tailored to demanding mobility needs."
},
{
"name": "Company Cab Madhapur",
"description": "Company Cab Madhapur offers end-to-end corporate cab management including employee transportation, executive travel, visitor movement, and on-demand mobility. With fleet monitoring, driver supervision, maintenance management, and compliance tracking, it provides a seamless, efficient, and scalable transport solution for businesses in Madhapur."
},
{
"name": "Office Transport Madhapur",
"description": "Office Transport Madhapur provides structured office commute operations with scheduled routes, GPS tracking, trained drivers, and shift-based deployment. Designed for corporate offices, IT parks, and BPO centers, it ensures punctual, safe, and consistent transportation for employees across Madhapur’s major commercial areas."
},
{
"name": "Employee Mobility Madhapur",
"description": "Employee Mobility Madhapur delivers comprehensive workforce transport solutions including shuttles, point-to-point cabs, monthly rentals, and on-demand mobility. With a focus on safety, reliability, route optimization, and automation, it ensures seamless employee movement for companies requiring scalable daily transportation."
},
{
"name": "Corporate Shuttle Madhapur",
"description": "Corporate Shuttle Madhapur provides high-volume staff shuttle services with AC buses, optimized multi-route planning, automated attendance, and real-time tracking. It is ideal for IT parks, BPOs, and large corporate campuses that require efficient and well-coordinated employee transportation throughout the workday."
}
],

"tableData": [
["Madhapur Corporate Cab", "IT Park Shuttle Madhapur"],
["Business Taxi Madhapur", "Employee Commute Madhapur"],
["Staff Pickup Drop Madhapur", "Monthly Cab Madhapur"],
["Affordable Corporate Cab Madhapur", "Best Cab Madhapur"],
["Outstation Cab Madhapur", "Sedan Cab Madhapur"],
["SUV Cab Madhapur", "Company Cab Madhapur"],
["Office Transport Madhapur", "Employee Mobility Madhapur"],
["Corporate Shuttle Madhapur", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Madhapur Hyderabad",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable corporate cab services in Madhapur Hyderabad, ensuring smooth and efficient transportation for employees and business executives across the IT and business hubs."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across Madhapur’s IT parks, offices, and commercial areas, helping employees reach work and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring a comfortable and secure commuting experience for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel in Madhapur."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible and tailored cab rental plans designed to meet the commuting requirements of companies and employees in Madhapur Hyderabad."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized regularly and equipped with modern safety features, providing secure and hygienic rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]









































  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Madhapur, Hyderabad?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies and IT offices located in Madhapur, Hyderabad.',
  },
  {
    question: 'What types of corporate transportation services do you offer in Madhapur?',
    answer: 'We provide employee transportation, corporate pickups and drops, last-mile connectivity, shuttle routes, airport transfers, and complete fleet management.',
  },
  {
    question: 'Do you support daily employee commute services in Madhapur?',
    answer: 'Yes, we offer well-organized daily commute solutions with route optimization, punctual pick-ups, and multi-shift support for corporate employees.',
  },
  {
    question: 'How can companies book corporate cab services in Madhapur?',
    answer: 'Companies can book through our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'What vehicle options are available for corporate travel in Madhapur?',
    answer: 'We provide hatchbacks, sedans, SUVs, Innova Crysta, luxury cars, tempo travellers, and electric cabs based on corporate needs.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts in Madhapur?',
    answer: 'Yes, we offer monthly, quarterly, and annual corporate transportation contracts with flexible pricing and complete fleet management.',
  },
  {
    question: 'Are your cabs equipped with GPS and safety features?',
    answer: 'All our vehicles are GPS-enabled, regularly sanitized, and driven by professionally trained and background-verified chauffeurs to ensure safety.',
  },
  {
    question: 'Do you support night shift and rotational shift services in Madhapur?',
    answer: 'Absolutely. We offer dependable transportation for night shifts, early-morning shifts, weekend operations, and rotational schedules.',
  },
  {
    question: 'What payment methods do you support for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and we also provide consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Shashank Bollu',
    feedback: 'Very reliable corporate cab service for our Madhapur office. Vehicles are clean and drivers are always on time.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rhea Nagesh',
    feedback: 'Professional service with excellent coordination. Our employees appreciate the smooth and safe daily travel.',
    rating: 5,
  },
];









































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Madhapur Hyderabad",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-madhapur.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited provides premium corporate cab services in Madhapur Hyderabad, offering IT park shuttle services, business taxis, employee commute solutions, staff pickup & drop, monthly corporate cab plans, outstation cab services, and complete fleet solutions for companies in the Madhapur business district.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-madhapur-hyderabad"
  }
};





  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Madhapur Hyderabad | IT Park & Employee Transport</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Madhapur Hyderabad, including IT park shuttle, employee commute, business taxis, staff pickup & drop, monthly corporate cab rentals, and outstation cab services."
  />

  <meta
    name="keywords"
    content="Madhapur Corporate Cab, IT Park Shuttle Madhapur, Business Taxi Madhapur, Employee Commute Madhapur, Staff Pickup Drop Madhapur, Monthly Cab Madhapur, Affordable Corporate Cab Madhapur, Best Cab Madhapur, Outstation Cab Madhapur, Sedan Cab Madhapur, SUV Cab Madhapur, Company Cab Madhapur, Office Transport Madhapur, Employee Mobility Madhapur, Corporate Shuttle Madhapur"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/79.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinmadhapurhyderabad;